import { FieldItemList, ListStringItem } from "./types";

export const singular_required_list_string_parser = (f: FieldItemList<ListStringItem>): string => f?.[0]?.value ?? ""
